<template>
  <div class="my-navigation1-div0">
    <div style="height: 80px;">
      <span class="my-navigation1-span1">产品分类及展示</span><br />
      <span class="my-navigation1-span2">我们专业生产实验室选矿成套设备及化验制样成套设备</span>
    </div>
    <div class="my-navigation1-div">
      <p v-for="index in count" :key="index">
        <Navigation2 :number="index"></Navigation2>
      </p>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Navigation2 from '@/components/index/Navigation2'
  import {
    getCount
  } from '@/api/navigation.js'

  export default {
    name: "Navigation1",
    components: {
      Navigation2,
    },
    data: function() {
      return {
        count: 0,
      }
    },
    methods: {},
    created() {
      getCount("navigation/getCount", this);
      document.documentElement.scrollTop=460;
    },
    mounted() {
      document.documentElement.scrollTop=460;
    },
    updated() {
      document.documentElement.scrollTop=460;
    }
  }
</script>

<style>
  .my-navigation1-div0 {
    background: #D3D4D6;
    margin-top: 45px;
  }

  .my-navigation1-div {
    width: 1200px;
    margin: 0 auto;
  }

  .my-navigation1-span1 {
    color: #555555;
    font-size: 34px;
    position: relative;
    top: 12px;
  }

  .my-navigation1-span2 {
    color: #555555;
    font-size: 22px;
    position: relative;
    top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/Navigation1.vue